<template>

  <div class="play-form box">
    <div class="field">
      <label class="label">Label</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="form.label"
          placeholder="Play label"
        />
      </div>
      <p v-if="errors.label" class="help is-danger">{{ errors.label }}</p>
    </div>

    <div class="field">
      <label class="label">Sort Order</label>
      <div class="control">
        <input
          class="input"
          type="number"
          v-model.number="form.sort_order"
          placeholder="0"
        />
      </div>
      <p v-if="errors.sort_order" class="help is-danger">{{ errors.sort_order }}</p>
    </div>

    <div class="field">
      <label class="label">Content</label>
      <div class="control">
        <textarea
          class="textarea"
          v-model="form.content"
          rows="6"
          placeholder="Contract language..."
        ></textarea>
      </div>
      <p v-if="errors.items" class="help is-danger">{{ errors.items }}</p>
    </div>

    <div class="field is-grouped">
      <div class="control">
        <button
          class="button is-success"
          @click="handleSave"
          :disabled="saving"
        >
          Save
        </button>
      </div>
      <div class="control">
        <button
          class="button"
          @click="$emit('cancel')"
          type="button"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>

</template>
<script>

  export default {

    props: {
      play: {
        type: Object,
        required: false,
        default: null,
      },
      errors: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      saving: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    data () {
      let play = this.play;
      return {
        form: {
          label: play ? play.label : '',
          sort_order: play ? play.sort_order : 0,
          content: play ? play.items.join('\n\n') : '',
        },
      };
    },

    methods: {

      handleSave () {
        let {label, sort_order, content} = this.form;
        let items = content.trim() ? [content.trim()] : [''];
        this.$emit('save', {label, sort_order, items});
      },

    },
  };

</script>

<style lang="scss" scoped>
  .play-form {
    margin-bottom: 1rem;
  }
</style>
